import React, {useEffect, useRef, useState} from 'react'
import {useGameState} from '../../hooks/useGameState'
import ifElse from 'ramda/src/ifElse'
import flip from 'ramda/src/flip'
import includes from 'ramda/src/includes'
import __ from 'ramda/src/__'
import curry from 'ramda/src/curry'
import pipe from 'ramda/src/pipe'
import converge from 'ramda/src/converge'
import prop from 'ramda/src/prop'
import map from 'ramda/es/map'
import {makeStyles} from '@material-ui/styles'
import {addIndex, always, identity} from 'ramda'
import WrittenText from '../common/WrittenText'
import {joinClassNames} from '../../helpers/classname'

const useStyles = makeStyles({
  letter: {
    display: 'inline-block',
    fontSize: ({fontSize}) => `${fontSize}em`,
    width: '0.8em',
  },
  wrapper: {
    whiteSpace: 'nowrap',
    position: 'relative',
    visibility: 'hidden',
  },
  wrapperVisible: {
    visibility: 'visible',
  },
})

function Word() {
  const {word, tries} = useGameState()
  const [fontSize, setFontSize] = useState(4)
  const {letter, wrapper, wrapperVisible} = useStyles({fontSize})
  const ref = useRef()
  const [isVisible, setVisible] = useState(false)

  useEffect(() => {
    if (getElemWidth(ref.current) > window.innerWidth) {
      setFontSize(Number((fontSize - 0.1).toPrecision(2)))
    } else {
      setVisible(true)
    }
  }, [fontSize, setFontSize, setVisible])

  return (
    <span
      ref={ref}
      className={isVisible ? joinClassNames(wrapper, wrapperVisible) : wrapper}
    >
      {renderLetters({tries, word, letter})}
    </span>
  )
}

function getElemWidth(elem) {
  return elem.getBoundingClientRect().width
}

const createLetterReplacer = pipe(
  flip(includes),
  curry(ifElse)(__, identity, always('_')),
)

const replaceUntriedLetters = converge(map, [
  pipe(prop('tries'), createLetterReplacer),
  prop('word'),
])

const renderLetters = converge(addIndex(map), [
  createLetterRenderer,
  replaceUntriedLetters,
])

function createLetterRenderer({letter}) {
  return (s, key) => React.createElement(WrittenText, {
    key,
    className: letter,
  }, s)
}

export default Word